const SEO_CONTENT_VIEW_TYPES = {
  DEFAULT: 'default',
  SPECIAL: 'special',
}

export {
  SEO_CONTENT_VIEW_TYPES,
}
